import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';

const Discount = ({ onChange, size = 'small', ...restProps }: any) => {
    return (
        <OutlinedInput
            type="number"
            size={size}
            className="smallInput"
            onChange={onChange}
            placeholder="Discount"
            inputProps={{
                min: 0,
                step: 10,
            }}
            {...restProps}
        />
    );
};

export default Discount;
